
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-post/2016/10/attribution-and-military-tactics-in-digital-marketing",
      function () {
        return require("private-next-pages/blog-post/2016/10/attribution-and-military-tactics-in-digital-marketing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-post/2016/10/attribution-and-military-tactics-in-digital-marketing"])
      });
    }
  